export default "__VITE_ASSET__hG_$fg_V__"